export enum TabRoutes {
  PreEstablishment = 'pre-establishment',
  Founder = 'founder',
  Investor = 'investor',
  CompanyInfo = 'company-info',
  Shareholders = 'shareholders',
  Partners = 'partners',
  Activities = 'activities',
  Capital = 'capital',
  Addresses = 'addresses',
  SupervisoryBoard = 'supervisory-board',
  Directors = 'directors',
  Managers = 'managers',
  Auditor = 'auditor',
  LegalAdvisor = 'legal-advisor',
  Bylaws = 'bylaws',
  Signatures = 'signatures',
  Contracts = 'contracts',
  ReferencePersons = 'reference-persons',
  Employment = 'employment',
  Attachments = 'attachments',
  register = "register",
}